import './App.css';
import React, { useState } from 'react';
import CustomButton from './Components/Buttons';
import { useTranslation, Trans } from 'react-i18next';
import LaptopIcon from '@mui/icons-material/Laptop';
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
import { useNavigate } from 'react-router-dom'; 

function PrototypePage() {
    const navigate = useNavigate();
    const {t} =useTranslation();
    const [width, setWidth] = useState(window.innerWidth);
    window.addEventListener('resize', () => setWidth(window.innerWidth));
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '10px' }}>
          <h2 style={{color: 'var(--primary-color)', marginBottom: '20px'}}>{t('selectPlatform')}</h2>
   
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
             <div onClick={() => window.open('https://demointegra.dicapta.com/', '_blank')} style={{ cursor: 'pointer', textAlign: 'center', margin: '0 15px' }}> 
               <LaptopIcon 
                 style={{ fontSize: '200px', color: 'var(--primary-color)' }} 
               />
               <div style={{ fontSize: '2rem', color: 'var(--primary-color)', marginTop: '-10px' }}>
                 {t('web')}
               </div>
             </div> 
   
             <div onClick={() => window.open('https://apps.apple.com/us/app/integra-video/id6670761608', '_blank')} style={{ cursor: 'pointer', textAlign: 'center', margin: '0 15px' }}> 
               <AppleIcon 
                 style={{ fontSize: '200px', color: 'var(--primary-color)' }} 
               />
               <div style={{ fontSize: '2rem', color: 'var(--primary-color)', marginTop: '-10px' }}>
                 {t('iPhone')}
               </div>
             </div> 
   
             <div onClick={() => window.open('https://play.google.com/store/apps/details?id=com.dicapta.integraapp', '_blank')} style={{ cursor: 'pointer', textAlign: 'center', margin: '0 15px' }}>
               <AndroidIcon 
                 style={{ fontSize: '200px', color: 'var(--primary-color)' }} 
               />
               <div style={{ fontSize: '2rem', color: 'var(--primary-color)', marginTop: '-10px' }}>
                 {t('Android')}
               </div>
             </div> 
          </div>
       </div>
     );
  }

  export default PrototypePage;